<template>
  <v-layout row>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="close">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        color="success"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <v-flex xs12 sm8 offset-sm2>
      <v-card class="mt-3">
        <v-toolbar color="blue" dark>
          <v-toolbar-title class="headline">Subscription Plan</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <form>
              <p class="headline text-md-center">
                Subscription plan details is coming soon.
              </p>
              <p class="mt-5 title">
                Please contact us for demo and other inquiries.
              </p>
              <v-layout row>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="formData.name"
                    label="Name"
                    required
                    outline
                    class="mr-1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="formData.email"
                    label="Email"
                    type="email"
                    required
                    outline
                    class="ml-1"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="formData.phone"
                    label="Phone"
                    type="number"
                    required
                    outline
                    class="mr-1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="formData.subject"
                    label="Contact Reason"
                    required
                    outline
                    class="ml-1"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 sm12 md12>
                  <v-textarea
                    v-model="formData.message"
                    label="Message"
                    required
                    box
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-spacer></v-spacer>
                <v-btn class="success" @click="submit">submit</v-btn>
              </v-layout>
            </form>
          </v-container>
        </v-card-text>

        <!-- <v-list two-line subheader>
          <v-list-tile v-for="item in items" :key="item.title" avatar>
            <v-list-tile-avatar>
              <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple>
                <v-icon color="grey lighten-1">info</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list> -->
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import axios from "axios";
  import { ROOT_URL } from "@/api/connectingUrls";
  export default {
    data() {
      return {
        items: [
          {
            icon: "folder",
            iconClass: "grey lighten-1 white--text",
            title: "Basic",
            subtitle: "0",
          },
          {
            icon: "business",
            iconClass: "grey lighten-1 white--text",
            title: "Premier",
            subtitle: "2000",
          },
          {
            icon: "corporate_fare",
            iconClass: "grey lighten-1 white--text",
            title: "Corporate",
            subtitle: "10000",
          },
        ],
        error: 0,
        errorMsg: "",
        dialog: false,
        file: null,
        snackbar: false,
        y: "top",
        x: "right",
        timeout: 3000,
        formData: {
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        },
        defaultData: {
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        },
      };
    },
    methods: {
      async submit() {
        // console.log(this.formData);
        try {
          return axios
            .post(`${ROOT_URL}/${"contact-us"}`, this.formData, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              // console.log(response);
              if (response.data.error == 0) {
                this.error = response.data.error;
                this.errorMsg = response.data.errorMsg;
                this.snackbar = true;
                setTimeout(() => {}, 400);
                this.close();
              } else {
                this.dialog = true;
                this.error = response.data.error;
                this.errorMsg = response.data.errorMsg;
              }
            });
        } catch (error) {
          // console.log(error);
        }
      },
      close() {
        this.dialog = false;
        setTimeout(() => {
          this.formData = Object.assign({}, this.defaultData);
        }, 300);
      },
    },
  };
</script>
<style scoped>
  .text-size {
    font-size: 16px;
  }
</style>
